import { ServiceMaker, methods, services } from "@/services";
import Api from "@/services/service-v2";

export const adminLogin = (data) =>
    ServiceMaker("/users/admin/login", methods.POST, services.nipige, data);

export const partnerLogin = (data) =>
    ServiceMaker("/users/partner/login", methods.POST, services.nipige, data);

export const createPartnerService = (data) =>
    ServiceMaker("/users/partner", methods.POST, services.nipige, data);

export const listPartners = (payload) => {
    let url = `/users/partner/list?limit=${payload.limit}&page=${payload.page}&type=${payload.category}`;
    if (payload.parentId) {
        url += `&parent=${payload.parentId}`;
    }
    return ServiceMaker(url, methods.GET, services.nipige, payload);
};

export const listTenantPartners = (payload) =>
    ServiceMaker(
        "users/partner/org-partner-list",
        methods.POST,
        services.nipige,
        payload,
    );

export const officeList = () =>
    ServiceMaker(`/users/partner/list`, methods.GET, services.nipige);

export const listProvider = () =>
    ServiceMaker(`/users/partner/list`, methods.GET, services.nipige);

export const fetchPartnerData = (id) =>
    ServiceMaker(
        `/users/partner/get-detail/${id}`,
        methods.GET,
        services.nipige,
    );

export const listChildPartners = (payload) =>
    ServiceMaker(
        `/users/partner/list?parent=${payload}`,
        methods.GET,
        services.nipige,
    );

export const fetchPartnerMarketSegment = (payload) =>
    ServiceMaker(
        `/catalog/api/catalog/read/catalog/partner-market-segments`,
        methods.GET,
        services.master,
    );
export const deletePartner = (id) =>
    ServiceMaker(
        `/users/partner/delete/${id}`,
        methods.DELETE,
        services.nipige,
    );

export const listPartnersByType = (payload) =>
    ServiceMaker(
        `/users/partner/list/bytype?type=${payload}`,
        methods.GET,
        services.nipige,
    );

export const fetchOfficeTypes = () =>
    ServiceMaker("/users/partner/list", methods.GET, services.nipige);

export const listPartnerTypeFilter = (payload) =>
    ServiceMaker(
        `/users/partner/list?type=${payload}`,
        methods.GET,
        services.nipige,
    );

export const partnerSearchByNameEmailPhone = (payload) =>
    ServiceMaker(
        `/users/partner/list?type=${payload.type}&${payload.key}=${payload.keyVal}&includeHierarchy=${payload.includeHierarchy}`,
        methods.GET,
        services.nipige,
    );

export const listStockPointsByTenant = () =>
    ServiceMaker(
        "/users/partner/tree?category=STOCK_POINT",
        methods.GET,
        services.nipige,
    );
export const allStockPointTenant = () =>
    ServiceMaker(
        `/users/partner/list-of-partner?allchild=y`,
        methods.GET,
        services.nipige,
    );

export const listOfficeByPartner = () =>
    ServiceMaker("/users/partner/sub-tree", methods.GET, services.nipige);

export const changePasswordPartner = (data) =>
    ServiceMaker(
        "/users/partner/update-password",
        methods.POST,
        services.nipige,
        data,
    );

////////////////
export const updatePartnerService = (id, data) =>
    ServiceMaker(
        `/users/partner/update/${id}`,
        methods.PUT,
        services.nipige,
        data,
    );
////////

export const getPartnerPreferences = (payload) =>
    ServiceMaker(
        `/users/partner/config?partner=${payload}`,
        methods.GET,
        services.nipige,
    );

export const updatePartnerPaymentPreferences = (payload) =>
    ServiceMaker(
        `/users/partner/set-preferences/${payload.id}`,
        methods.POST,
        services.nipige,
        payload.data,
    );

export const getPartnerPaymentPreferences = (payload) =>
    ServiceMaker(
        `/users/partner/get-preferences/${payload}`,
        methods.GET,
        services.nipige,
    );

export const updatePartnerPaymentConfig = (payload) =>
    ServiceMaker(
        `/payments/provider-config/set/${payload.id}`,
        methods.POST,
        services.master,
        payload.data,
    );

export const updatePartnerPreferences = (payload) =>
    ServiceMaker(
        `/users/partner/config`,
        methods.POST,
        services.nipige,
        payload,
    );

export const getPartnerListLite = (payload) =>
    ServiceMaker(
        `/users/partner/list/partners?TYPE=${payload.type}`,
        methods.GET,
        services.nipige,
    );

export const getPartnerPaymentConfig = (payload) =>
    ServiceMaker(
        `/payments/config/get/${payload}`,
        methods.GET,
        services.master,
    );

export const getPartnerParentData = (payload) =>
    ServiceMaker(
        `/users/partner/get-parent/${payload}`,
        methods.GET,
        services.nipige,
    );

export const getSellerProviderConfig = (payload) =>
    ServiceMaker(
        `/payments/provider-config/get/${payload}`,
        methods.GET,
        services.master,
    );

export const getPartnerDetailsById = (payload) =>
    ServiceMaker(
        `/cap/users/partner/get-detail/${payload}`,
        methods.GET,
        services.master,
    );
export const getApprovalList = (payload) =>
    ServiceMaker(
        `cap/users/approval-request/list?${payload}`,
        methods.GET,
        services.master,
    );

export const updateApprovalRequest = (payload) =>
    ServiceMaker(
        `cap/users/approval-request/${payload.id}`,
        methods.PUT,
        services.master,
        payload.data,
    );

export const getApprovalRequestById = (payload) =>
    Api().$http.get(`/cap/users/approval-request/${payload}`);

export const offlinePartner = (id, payload) =>
    Api().$http.put(`/cap/users/partner/offline/${id}`, payload);

export const partnerStatusUpdate = (id, payload) =>
    Api().$http.post(`/cap/users/partner/update-status/${id}`, payload);

export const getAnalyticReport = (payload) =>
    Api().$http.post(`dashboard/analytic-report/filter`, payload);

export const getBulkAnalyticReport = (payload) =>
    Api().$http.post(`dashboard/bulk-analytic-report/filter`, payload);

export const getSlaReportList = (payload) =>
    Api().$http.post(`dashboard/report-list/filter`, payload);

export const getPartnerCustomer = (payload) =>
    Api().$http.post(`/cap/users/partner-customer/filter`, payload);

export const createCustomer = (payload) =>
    Api().$http.post(`/cap/users/partner-customer`, payload);

export const updateCustomer = (id, payload) =>
    Api().$http.put(`/cap/users/partner-customer/${id}`, payload);

export const getBulkCustomerList = (payload) =>
    Api().$http.get(
        `/bulk-upload/bulk-import-report/list?jobType=CUSTOMER_IMPORT`,
        payload,
    );

export const bulkCustomerImport = (payload) =>
    Api().$http.post(`/bulk-upload/bulk-customer-import`, payload);

export const getStockPointByProvider = (payload) =>
    Api().$http.post("/cap/users/partner/get-providers", payload);

export const viewAgentDetails = (id) =>
    Api().$http.get(`/cap/users/admin/view-agent/${id}`);

export const updateUser = (id, payload) =>
    Api().$http.put(`/cap/users/admin/update-profile/${id}`, payload);

export const updateProfile = (id, payload) =>
    Api().$http.put(`cap/users/partner/update/${id}`, payload);

export const updateKyc = (data, payload) =>
    Api().$http.put(
        `/cap/users/admin/update-kyc/${data.userId}/${data.kycId}`,
        payload,
    );

export const walletList = (payload) =>
    Api().$http.get(`/wallet/resource-master/list`, payload);

export const fetchRequestDownload = (payload) =>
    ServiceMaker(
        `/batch-processor/request-download/list?status=${payload.status}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&type=${payload.type}`,
        methods.GET,
        services.master,
    );

export const createRequestDownload = (payload) =>
    ServiceMaker(
        `/batch-processor/request-download/create`,
        methods.POST,
        services.master,
        payload,
    );
